import { Dispatch } from "redux";
import { fetchOnce } from "../../common/utils/fetchOnce";
import { ApiAction } from "./apiActions";

interface Extenders<TActionCreator> {
    sourceActionCreator: TActionCreator;
    reset: () => void;
}

interface RunOnce {
    (creator: F<ApiAction>): F<ApiAction> & Extenders<F<ApiAction>>;
    <A1>(creator: F1<A1, ApiAction>): F1<A1, ApiAction> & Extenders<F1<A1, ApiAction>>;
}

/**
 * Retunrs action creator that execute specified api action only once.
 * @param apiActionCreator (for example api.postJson(() => ({...}))
 */
const runOnceImpl = (apiActionCreator: F<ApiAction>) => {
    const createAction = () => fetchOnce((dispatch: Dispatch) => dispatch(apiActionCreator()));

    let action = createAction();
    const result: Extenders<any> = (() => (dispatch: Dispatch) => action(dispatch)) as any;

    if (process.env.NODE_ENV !== "production") {
        // sourceActionCreator is added just for tests.
        result.sourceActionCreator = apiActionCreator;
    }
    result.reset = () => {
        action = createAction();
    };

    return result;
};

export const runOnce: RunOnce = runOnceImpl as any;
